export default __webpack_public_path__ + "static/media/AiOlentzero.0b1d8373.mp3";